import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Form from '../../components/forms/UserForm';
import { breadcrumbs } from '../../../../actions/appActions';
import { convert } from '../../converts';
import { isInternal } from '../../CroUtils';
import { getDecodedUser } from '../../../../utils/login';
import { updateInternalUserPhone } from '../../CroActions';

const postProcess = data => {
  const converted = convert(data, {
    created: date => new Date(date).toLocaleString(),
  });
  return { ...converted, activeLabel: data.active ? 'Ano' : 'Ne' };
};

const isCurrentUserAdmin = () => {
  const user = getDecodedUser();
  return Array.isArray(user?.aut) && user.aut.includes('ROLE_INTERNAL_ADMIN');
};

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: 'Správci' }, { label: 'Detail správce' }],
  url: `/spravce/api/spravci/${params.id}`,
  disabled: true,
  phoneDisabled: !isCurrentUserAdmin(),
  postProcess,
  userId: params.id,
});

const mapDispatchToProps = (dispatch, { params, auth }) => ({
  breadcrumbs: (...args) => dispatch(breadcrumbs(...args)),
  onShowHistory: (params.id && isInternal(auth))
    ? () => dispatch(push(`${auth.startUrl}/spravci/${params.id}/historie`))
    : null,
  onSubmit: (values) => dispatch(updateInternalUserPhone(params.id, values.phone)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
